import { Grid, Stack, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import MainCard from 'ui-component/cards/MainCard';
import NewFormItem from './NewFormItem';

interface DragAreaProps {
  items?: Array<any>;
  setItems?: (items: Array<any>) => void;
  selectedItem?: any;
  setSelectedItem?: (selectedItem: any) => void;
  formRef?: any;
  handleDragOver?: (e: any) => void;
  handleDrop?: (e: any) => void;
  currentStep?: number;
  steps?: Array<any>;
  defaultStepName?: string;
  type?: string;
}

const DragArea = ({
  items,
  setItems,
  selectedItem,
  setSelectedItem,
  formRef,
  handleDragOver,
  handleDrop,
  steps,
  currentStep,
  defaultStepName,
  type
}: DragAreaProps) => {
  const intl = useIntl();
  console.log(items, 'items from drag area');
  return (
    <MainCard content={false}>
      <Grid container sx={{ minHeight: '91vh' }} onDragOver={handleDragOver} onDrop={handleDrop} ref={formRef}>
        {steps?.length ? (
          <Stack direction="row" alignItems="center" justifyContent="flex-start" width="100%">
            <Typography sx={{ fontSize: 18, color: '#565656', p: 2, fontWeight: 500 }}>
              {type === 'stepper' ? steps[currentStep ?? 0]?.title : defaultStepName}{' '}
            </Typography>
            <Typography sx={{ color: '#8F8F8F', fontSize: 16 }}>{intl.formatMessage({ defaultMessage: '(Form Preview)' })}</Typography>
          </Stack>
        ) : null}
        {items && items?.length ? (
          items?.map((item, index, arr) => {
            const width = item?.width || 12;

            return (
              <Grid item xs={12} sm={width} key={item.id} sx={{ marginBottom: '20px' }}>
                <NewFormItem
                  isDashBoard={false}
                  item={item}
                  steps={steps}
                  currentStep={currentStep}
                  isFirstItem={index === 0}
                  isLastItem={index === arr.length - 1}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  items={items}
                  setItems={setItems}
                  choices={item?.choices}
                  showInput={item?.showInput}
                  inputsLabel={item?.inputsLabel}
                  inputsLabelFrench={item?.inputsLabelFrench}
                  description={item?.description}
                />
              </Grid>
            );
          })
        ) : (
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '91vh' }}>
            <Typography sx={{ fontWeight: 400, fontSize: 18, color: '#8F8F8F' }}>
              {intl.formatMessage({ defaultMessage: 'Drag and drop elements here' })}
            </Typography>
          </Grid>
        )}
      </Grid>
    </MainCard>
  );
};

export default DragArea;
